import * as React from "react";
import Modal from "react-bootstrap-modal";
import bind from 'bind-decorator';
import Draggable from 'react-draggable';



export interface IProps {
    title: JSX.Element | JSX.Element[] | any;
    buttons?: any;
    dialogClassName?: string;
    children?: JSX.Element | JSX.Element[] | any;
    onShow?: () => void;
    onHide?: () => void;
}
 
export interface State {
    open: boolean
}

export class ModalComponent extends React.Component<IProps, State> {
    constructor(props) {
        super(props);
        this.state = {
            open: false
        }
    }

    protected modalPlugin: Modal;

    @bind
    public show() {
        this.setState({ open: true });
        if (this.props.onShow != null)
            this.props.onShow();
    }

    @bind
    public hide() {
        this.setState({ open: false });
        if (this.props.onHide != null)
            this.props.onHide();
    }

    componentDidMount() {

    }

    componentWillUnmount() {
        this.setState({ open: false });
    }

    render() {
        return <Modal
            backdrop={false}
            dialogClassName={this.props.dialogClassName}
            show={this.state.open}
            onHide={this.hide}
            ref={x => this.modalPlugin = x}
            aria-labelledby="ModalHeader">
            <Draggable handle=".handle">
                <div>
                    <Modal.Header closeButton className="handle bg-modal">
                        <Modal.Title id='ModalHeader'>{this.props.title ?  this.props.title : ""}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="modalBody">
                        {this.props.children ? this.props.children :""}
                    </Modal.Body>
                    <Modal.Footer className="handle">
                        {this.props.buttons ? this.props.buttons : ""}
                    </Modal.Footer>
                </div>
            </Draggable>
        </Modal>;

    }
}